module.exports = __webpack_public_path__ + "media/images/landing/eno/product-21-4233f4ab13a6129ea1841750dd6ce9e6.png";